module.exports = __webpack_public_path__ + "static/img/Wikiversity-Mooc-Icon-Edit.svg.6d3859ea.png";